import { KnownBusinessEntityRepository } from "@/repositories/known-business-entity-repository.ts"
import type { IKnownBusinessEntity } from "@/interfaces/api/known-business-entity.interface.ts"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"
import { useKnownBusinessEntityStore } from "@/store/known-business-entities.store.ts"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"

export class KnownBusinessEntityController extends GenericModelController<
  KnownBusinessEntity,
  IKnownBusinessEntity,
  KnownBusinessEntityRepository
> {
  constructor() {
    const knownBusinessEntityStore = useKnownBusinessEntityStore()
    const { knownBusinessEntities } = storeToRefs(knownBusinessEntityStore)
    const storeFunctionsConfig = {
      collection: knownBusinessEntities
    }

    super(KnownBusinessEntity, storeFunctionsConfig, new KnownBusinessEntityRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      KnownBusinessEntity,
      knownBusinessEntities
    )
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public create(..._args: unknown[]): Promise<KnownBusinessEntity | undefined> {
    throw new Error("Cannot use create(). Use createFromRegistrationNumber() instead.")
  }

  public async createFromRegistrationNumber(
    countryOfRegistration: string,
    registrationNumber: string,
    customName?: string
  ): Promise<KnownBusinessEntity | undefined> {
    const result = await this.apiFunctions
      .getRepository()
      .createFromRegistrationNumber({ countryOfRegistration, registrationNumber, customName })
    return await this.storeFunctions.createModel(result.data)
  }
}
